import React, { Component } from 'react';
import { Dropdown, Row } from 'react-bootstrap';
import Loading from '../../components/common/Loading';

class SelectQuickPicker extends Component {
  constructor(props) {
    super(props);
 
    this.updateTitle = this.updateTitle.bind(this);
    this.updateOptions = this.updateOptions.bind(this);
    this.updateSelectValue = this.updateSelectValue.bind(this);
 
    const { defaultValue } = this.props;
    const selectValue = defaultValue ? defaultValue : 'all';
 
    //init filter state
    this.state = {
      selectValue: selectValue, // default all
      title: null,  // default {'all': 'All'}
      options: null  // default ['all']
    }
  }
 
  updateTitle() {
    const title = (this.props.title) ? this.props.title : {'all': 'All'};
    this.setState({
      title: title
    });
  }
 
  updateOptions() {
    const options = (this.props.options) ? this.props.options : ['all'];
    this.setState({
      options: options
    });
  }
 
  updateSelectValue(value) {
    this.setState({
      selectValue: value
    });
  }
 
  selectTypeItem = (key, value) => {
    const {doActions} = this.props;
    if (doActions) {
      const { filterId } = this.props;
      if (filterId === 'organization-pick' || filterId === 'group-bar') {
        this.setState({
          selectValue: key
        });
        doActions(key, value);
      }
      else if (filterId === 'model-detail-inheritancePosition' || filterId === 'model-group-detail-org' || filterId === 'device-pick') {
        this.setState({
          selectValue: key
        });
        doActions(value);
      }
      else {
        doActions(key);
      }
    }
  }
 
  renderMenuItems = (options) => {
    return options.map((option, index) => {
      const { filterId } = this.props;
      const { selectValue, title } = this.state;
      let clsMenuSelection, clsTextSelection;
      if (selectValue === option) {
        clsMenuSelection = 'icon-menu-selection';
        clsTextSelection = 'radio-select-text';
      } else {
        clsMenuSelection = 'icon-radiobutton-none';
        clsTextSelection = 'radio-text';
      }
      if(filterId === 'abnormal-operation-pick'){
        return (
          <Dropdown.Item key={index} onClick={() => this.selectTypeItem(option, title[option])} className='select-item' title={title[option]}>
            <span className='radio-icon-area'><span id={filterId + '-radio-select-type-' + option } className={clsMenuSelection}/></span>
            <span className={clsTextSelection}><span className={title[option]}></span> </span>
          </Dropdown.Item>
        )
      }
      else{
        return (
          <Dropdown.Item key={index} onClick={() => this.selectTypeItem(option, title[option])} className='select-item' title={title[option]}>
            <span className='radio-icon-area'><span id={filterId + '-radio-select-type-' + option } className={clsMenuSelection}/></span>
            <span className={clsTextSelection}>{ title[option] }</span>
          </Dropdown.Item>
        )
      }
    });
  }
 
  componentDidMount() {
    // if call render will do this method
    this.updateTitle();
    this.updateOptions();
  }
 
  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.title !== this.props.title) {
      this.updateTitle();
    }
    if (prevProps.options !== this.props.options) {
      this.updateOptions();
      this.updateSelectValue(this.props.defaultValue);
    }
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.updateSelectValue(this.props.defaultValue);
    } else if (prevProps.value !== this.props.value) {
      this.updateSelectValue(this.props.value);
    } else if (prevProps.selectValue !== this.props.selectValue) {
      this.updateSelectValue(this.props.selectValue);
    }
  }
 
  render() {        
    const { filterId, disabled } = this.props;
    const { options, title, selectValue } = this.state;
 
    if (!options || !title) {
      return (
        <Loading loading={true}></Loading>
      );
    } else {
      return (
        <div id={this.props.filterId} className='area-quick-picker'>
          <Row>
              <div className='area-picker-menu'>
                <input type='hidden' id={filterId + '-filterSearch-type'} name='searchType' value={ selectValue }/>
                <Dropdown>
                  <Dropdown.Toggle variant="success" className='dropdown-toggle' disabled={disabled}>
                    { this.props.filterId !== 'abnormal-operation-pick' ? <label className='menu-choose-word'>{ title[selectValue] }</label> :
                      <label className='menu-choose-word'><span className={ title[selectValue] }></span></label>
                    }                    
                    <span className='icon-btn-arrow-down-2-n' />              
                  </Dropdown.Toggle>
                  <Dropdown.Menu flip={true}>
                    { this.renderMenuItems(options, this.props.filterId) }
                  </Dropdown.Menu>            
                </Dropdown>
              </div>
          </Row>        
        </div>
      )
    }
  }
}
 
export default SelectQuickPicker

